import { apiClient } from "@nabble/sdk";

export interface Organization {
  id: string;
  name: string;
  users: number;
  createdAt: string;
}

/** The organization created with the installation; it can be renamed but not deleted. */
export const DEFAULT_ORGANIZATION_ID = "00000000-0000-0000-0000-000000000100";

export function fetchOrganizations(): Promise<Organization[]> {
  return apiClient<Organization[]>("/api/admin/organizations");
}

export function createOrganization(name: string): Promise<{ id: string }> {
  return apiClient<{ id: string }>("/api/admin/organizations", { method: "POST", body: { name } });
}

export function renameOrganization(id: string, name: string): Promise<void> {
  return apiClient<void>(`/api/admin/organizations/${id}`, { method: "PUT", body: { name } });
}

export function deleteOrganization(id: string): Promise<void> {
  return apiClient<void>(`/api/admin/organizations/${id}`, { method: "DELETE" });
}
